module.exports = __webpack_public_path__ + "static/media/being_changes-min.9b95a039.jpg";